// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"370":"0a33cdfdf8e5ccbea26d","781":"aea3cd518ce5acb06bb2"}[chunkId] + ".js";
};